"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _reactRedux = require("react-redux");
var _selectors = require("../../redux/margin/selectors");
var _TradingLayout = _interopRequireDefault(require("./TradingLayout"));
var _config = _interopRequireDefault(require("../../config"));
var _snackbarActions = require("../../redux/actions/snackbarActions");
var _modalActions = require("../../redux/actions/modalActions");
var _marginSelectors = require("../../../lib/redux/margin/selectors/marginSelectors");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
var mapStateToProps = function mapStateToProps(state) {
  return {
    MarginBorrowerEnabled: (0, _marginSelectors.marginBorrowerEnabledSelector)(state),
    isMarginActive: (0, _selectors.isMarginActiveSelector)(state),
    isMarginEnabledSelector: (0, _selectors.isMarginEnabledSelector)(state),
    config: _config["default"]
  };
};
var _default = exports["default"] = (0, _reactRedux.connect)(mapStateToProps)(_TradingLayout["default"]);